import throttle from "lodash/throttle";

// must be in-sync with $sidebar-vert-padding in constants.scss
const sidebarVertPadding = 20;

export default class Header {
    constructor() {
        this.lastScrollPos = 0;
    }

    resetSidebarPadding($sidebar, searchbarHeight, navbarHeight, cookieBannerHeight) {
        $sidebar.css(
            "padding-top",
            `${searchbarHeight + sidebarVertPadding + cookieBannerHeight + navbarHeight}px`
        );
    }

    addEventListeners(selectors) {
        const $navbarRootComponent = $(selectors.navbarComponentRoot);
        const $sidebar = $(selectors.sidebarSelector);
        const $searchbar = $(selectors.searchBarSelector);
        const $cookieBannerWrapper = $(selectors.cookieBannerWrapper);

        const searchbarHeight = $searchbar.outerHeight();

        $(window).on(
            "scroll",
            throttle(() => {
                const scrollPos = $(window).scrollTop();

                const isScrolled = scrollPos > 0;
                const isScrollingDown = this.lastScrollPos < scrollPos;

                const navbarHeight = $navbarRootComponent.outerHeight();
                const cookieBannerHeight = $cookieBannerWrapper.outerHeight() || 0;
                const isShowingCookies = cookieBannerHeight > 0 && scrollPos < cookieBannerHeight;

                if (!isScrolled && !isShowingCookies) {
                    return;
                }

                Object.values(selectors).forEach((selector) => {
                    if (isScrollingDown && !isShowingCookies) {
                        $(selector).css(
                            "transform",
                            `translateY(-${navbarHeight}px)`
                        );
                    } else {
                        $(selector).css("transform", "");
                    }
                });

                $sidebar.css("transform", "");
                $searchbar.css("top", navbarHeight);

                if (isScrollingDown && !isShowingCookies) {
                    $sidebar.css(
                        "padding-top",
                        `${searchbarHeight + sidebarVertPadding}px`
                    );
                } else {
                    if(isShowingCookies) {
                        this.resetSidebarPadding(
                            $sidebar,
                            searchbarHeight,
                            navbarHeight,
                            cookieBannerHeight - scrollPos
                        );
                    } else {
                        this.resetSidebarPadding(
                            $sidebar,
                            searchbarHeight,
                            navbarHeight,
                            0
                        );
                    }
                }
                this.lastScrollPos = scrollPos;
            }, 50)
        );

        // Reposition the elements dependent on the navbar position when the
        // microbanner closes
        if (MutationObserver) {
            const observer = new MutationObserver(() => {
                const navbarHeight = $navbarRootComponent.outerHeight();

                this.resetSidebarPadding(
                    $sidebar,
                    searchbarHeight,
                    navbarHeight
                );
                $searchbar.css("top", navbarHeight);
            });

            if ($navbarRootComponent[0]) {
                observer.observe($navbarRootComponent[0], {
                    childList: true,
                });
            }
        }
    }

    mount(selectors) {
        const $navbarComponentRoot = $(selectors.navbarComponentRoot);
        const $sidebar = $(selectors.sidebarSelector);
        const $searchbar = $(selectors.searchBarSelector);
        const $cookieBannerWrapper = $(selectors.cookieBannerWrapper);

        const searchbarHeight = $searchbar.outerHeight();
        const navbarHeight = $navbarComponentRoot.outerHeight();
        const cookieBannerHeight = $cookieBannerWrapper.outerHeight() || 0;

        this.addEventListeners(selectors);

        this.resetSidebarPadding($sidebar, searchbarHeight, navbarHeight, cookieBannerHeight);
        $searchbar.css("top", navbarHeight);
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/header.js